import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Returns the canonical guest site base URL used for QR codes.
// Prefers the host-configured Settings.public_site_url, falling back to the current origin.
export function usePublicSiteBase() {
  const [base, setBase] = useState(typeof window !== "undefined" ? window.location.origin : "");
  useEffect(() => {
    api.get("/settings").then((r) => {
      const u = (r.data?.public_site_url || "").trim().replace(/\/+$/, "");
      if (u) setBase(u);
    }).catch(() => {});
  }, []);
  return base;
}
